import { AnimatePresence } from 'framer-motion';
import { FC, useState } from 'react';
import styled from 'styled-components';

import Text from '@/components/Text';

import BlacklistModal from './BlacklistModal';

export const Button = styled.button.attrs({ type: 'button' })`
  display: flex;
  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  color: ${({ theme }) => theme.colors.black};
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.white};

  svg {
    margin-right: 8px;
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

interface Props {
  whitelist?: boolean;
}

const Blacklist: FC<Props> = ({ whitelist = false }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button onClick={() => setShowModal(true)}>
        <Text as="span" $type="smallBold">
          {whitelist ? 'Whitelist' : 'Blacklist'}
        </Text>
      </Button>
      <AnimatePresence>
        {showModal && (
          <BlacklistModal
            onClose={() => setShowModal(false)}
            whitelist={whitelist}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default Blacklist;
